gb.defer(function () {
    let _ = {};
    let store = {
        maps: {},
        markers: []
    };

    let formatAddress = function (address) {
        let result = "";

        if (address.streetNumber) {
            result += address.streetNumber;
            result += ', ';
        }

        if (address.streetName) {
            result += address.streetName;
            result += ', ';
        }

        if (address.city) {
            result += address.city;
            result += ', ';
        }

        if (address.state) {
            result += address.state;
            result += ', ';
        }

        if (address.zipcode) {
            result += address.zipcode;
            result += ', ';
        }

        if (address.country) {
            result += address.country;
        }

        return result;
    };

    _.init = function (options) {
        options = $.extend({
            zoom: 13
        }, options);

        if (options.lat && options.lng) {
            let coord = new google.maps.LatLng(options.lat, options.lng);
            store.maps[options.id] = new google.maps.Map(document.getElementById(options.id), {
                zoom: options.zoom,
                center: coord
            });
            store.markers.push(new google.maps.Marker({
                map: store.maps[options.id],
                position: coord
            }));
        } else if (options.address) {
            _.getLocationByAddress(options.address, function (lat, lng) {
                let coord = new google.maps.LatLng(lat, lng);
                store.maps[options.id] = new google.maps.Map(document.getElementById(options.id), {
                    zoom: options.zoom,
                    center: coord
                });
                store.markers.push(new google.maps.Marker({
                    map: store.maps[options.id],
                    position: coord
                }));
            });
        } else {
            store.maps[options.id] = new google.maps.Map(document.getElementById(options.id), {
                zoom: 1,
                center: new google.maps.LatLng(0, 0)
            });
        }

        let $element = $('#' + options.id);
        let lastHeight = $element.height();

        (function checkForChanges() {
            if ($element.height() != lastHeight) {
                lastHeight = $element.height();
                console.log(lastHeight);
                let map = store.maps[options.id];
                let center = map.getCenter();
                google.maps.event.trigger(map, "resize");
                map.panTo(center);
            }

            setTimeout(checkForChanges, 500);
        })();
    };

    _.updateByAddress = function (mapid, address) {
        _.getLocationByAddress(address, function (lat, long) {
            _.updateByLatLong(mapid, lat, long);
        });
    };

    _.updateByLatLong = function (mapid, lat, long) {
        let map = store.maps[mapid];
        let cordinates = new google.maps.LatLng(lat, long);

        map.setCenter(cordinates);

        for (var i = 0; i < store.markers.length; i++) {
            store.markers[i].setMap(null);
        }

        store.markers.push(new google.maps.Marker({
            map: map,
            position: cordinates
        }));
    };

    _.getLocationByAddress = function (address, callback) {
        (new google.maps.Geocoder()).geocode({ 'address': formatAddress(address) }, function (results, status) {
            let result = null;
            if (status === google.maps.GeocoderStatus.OK) {
                result = results[0].geometry.location;
                $('input[name="GolfClubLatitude"]').val(result.lat());
                $('input[name="GolfClubLongtitude"]').val(result.lng());
            } else {
                result = new google.maps.LatLng(0, 0);
            }

            $.isFunction(callback) && callback(result.lat(), result.lng());
        });
    };

    _.getCurrentGPS = function (callback) {
        // Try W3C Geolocation (Preferred)
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                callback(position.coords.latitude, position.coords.longitude);
            }, function () {
                callback(0, 0);
            });
        } else { // Browser doesn't support Geolocation
            callback(0, 0);
        }
    };

    window.maps = _;
});